import gql from "graphql-tag";

export default gql`
query getUser($id: String!) {
    user @client {
        id
        username
        photoURL
        token
    }
}`;



// WEBPACK FOOTER //
// ./src/queries/getUser.ts